import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const ExternalCalendarIcon: FunctionComponent<ExternalCalendarIconProps> = ({ size = 24, fillColor }) => {
  const { colors } = useTheme()
  return (
    <Svg width={size} height={size} fill='none'>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18 4.25H17.5V2.5C17.5 2.09 17.16 1.75 16.75 1.75C16.34 1.75 16 2.09 16 2.5V4.25H8V2.5C8 2.09 7.66 1.75 7.25 1.75C6.84 1.75 6.5 2.09 6.5 2.5V4.25H6C4.34 4.25 3 5.59 3 7.25V19.25C3 20.91 4.34 22.25 6 22.25H18C19.66 22.25 21 20.91 21 19.25V7.25C21 5.59 19.66 4.25 18 4.25ZM6 5.75C5.17 5.75 4.5 6.42 4.5 7.25V8.25H19.5V7.25C19.5 6.42 18.83 5.75 18 5.75H6ZM19.5 19.25C19.5 20.08 18.83 20.75 18 20.75H6C5.17 20.75 4.5 20.08 4.5 19.25V9.75H19.5V19.25Z'
        fill={fillColor || colors.iconActive}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.1396 10.875C9.90525 10.875 8.08764 12.6516 8.02161 14.8699H7.2509C6.91622 14.8699 6.74768 15.2738 6.98828 15.5083L8.38095 16.9059C8.52964 17.0546 8.76359 17.0546 8.91228 16.9059L10.3055 15.5127L10.3069 15.5113C10.5362 15.2746 10.3758 14.8699 10.0373 14.8699L9.27116 14.8699C9.33676 13.3439 10.5977 12.1237 12.1396 12.1237C12.5185 12.1237 12.8868 12.1958 13.2151 12.3338C13.448 12.4308 13.7054 12.3575 13.8709 12.192C14.1897 11.8732 14.0761 11.3369 13.6598 11.1688C13.1904 10.978 12.675 10.875 12.1396 10.875ZM15.8982 13.0887C15.7496 12.94 15.5156 12.94 15.3669 13.0887L13.9737 14.4819C13.7394 14.7163 13.9069 15.1198 14.2419 15.1198L15.008 15.1198C14.9424 16.6458 13.6815 17.8659 12.1396 17.8659C11.7607 17.8659 11.3924 17.7938 11.0641 17.6558C10.8312 17.5588 10.5738 17.6321 10.4083 17.7977C10.0895 18.1165 10.2031 18.6528 10.6194 18.8208C11.0888 19.0117 11.6042 19.1147 12.1396 19.1147C14.3739 19.1147 16.1916 17.3381 16.2576 15.1198H17.0283C17.363 15.1198 17.5315 14.7157 17.2908 14.4813L15.8982 13.0887Z'
        fill={fillColor || colors.iconActive}
      />
    </Svg>
  )
}

export type ExternalCalendarIconProps = {
  size?: string | number
  fillColor?: string
}
